import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';
import { useTranslation } from '../context/TranslationContext';
import SEO from '../components/SEO';

var COPY = {
  en: { title: 'This page has moved', body: 'The link you followed points to a page that no longer exists. Everything is still here — just one tap away.', shop: 'Browse the shop', downloads: 'My downloads', home: 'Home' },
  es: { title: 'Esta página se ha movido', body: 'El enlace que seguiste apunta a una página que ya no existe. Todo sigue aquí, a un solo toque.', shop: 'Ver la tienda', downloads: 'Mis descargas', home: 'Inicio' },
  de: { title: 'Diese Seite wurde verschoben', body: 'Der Link führt zu einer Seite, die es nicht mehr gibt. Alles ist weiterhin da — nur einen Klick entfernt.', shop: 'Zum Shop', downloads: 'Meine Downloads', home: 'Startseite' },
  fr: { title: 'Cette page a été déplacée', body: "Le lien que vous avez suivi mène à une page qui n'existe plus. Tout est toujours là, à un clic.", shop: 'Voir la boutique', downloads: 'Mes téléchargements', home: 'Accueil' },
  it: { title: 'Questa pagina è stata spostata', body: 'Il link che hai seguito porta a una pagina che non esiste più. È tutto ancora qui, a un tocco di distanza.', shop: 'Vai al negozio', downloads: 'I miei download', home: 'Home' },
  ja: { title: 'このページは移動しました', body: 'お使いのリンク先のページは現在ありません。コンテンツはすべてこちらからご覧いただけます。', shop: 'ショップを見る', downloads: 'マイダウンロード', home: 'ホーム' },
  uk: { title: 'Цю сторінку перенесено', body: 'Посилання веде на сторінку, якої більше немає. Усе на місці — лише один дотик.', shop: 'Перейти до крамниці', downloads: 'Мої завантаження', home: 'Головна' },
};

function NotFoundPage() {
  var { language } = useTranslation();
  var c = COPY[language] || COPY.en;
  var btn = 'px-6 py-3 rounded-full text-sm font-semibold transition-colors duration-200';

  return (
    <Layout>
      <SEO title="Page Not Found" noindex={true} />
      <div className="pt-32 pb-24 bg-black min-h-screen" data-testid="not-found-page">
        <div className="max-w-2xl mx-auto px-6 lg:px-12">
          <p className="text-[#d4af37] text-xs uppercase tracking-[0.3em] mb-4">404</p>
          <h1 data-testid="not-found-title" className="text-4xl sm:text-5xl font-bold text-white mb-5">{c.title}</h1>
          <p className="text-neutral-400 text-base mb-10">{c.body}</p>
          <div className="flex flex-wrap gap-3">
            <Link to="/shop" data-testid="not-found-shop" className={btn + ' bg-[#d4af37] text-black hover:bg-[#e8c759]'}>{c.shop}</Link>
            <Link to="/my-downloads" data-testid="not-found-downloads" className={btn + ' border border-white/20 text-white hover:border-[#d4af37] hover:text-[#d4af37]'}>{c.downloads}</Link>
            <Link to="/" data-testid="not-found-home" className={btn + ' text-neutral-400 hover:text-white'}>{c.home}</Link>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default NotFoundPage;
